import PaginationNext from './pagination-next';
import PaginationPrevious from './pagination-previous';

const CustomPagination = {
    Next: PaginationNext,
    Previous: PaginationPrevious,
    name: 'test',
};

export default CustomPagination;
